import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../store/actions/auth-actions';
import { Roles } from '../../helpers/consts/roles';

import { Form, Input, Button, Checkbox, Col, Row, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import classes from './LoginForm.module.css';
import logo from '../../assets/img/Logo.svg'

const LoginForm = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  let location = useLocation();
  let path = location.state?.from?.pathname || '';
  const isLoading = useSelector((state) => state.auth.isLoading);

  const onFinish = async (values) => {
    try {
      const data = await dispatch(loginUser(values)).unwrap();
      switch (data.data.user.role.name) {
        case Roles.ROOT:
          path = path || '/vehicles';
          break;
        case Roles.ADMIN:
          path = path || '/vehicles';
          break;
        case Roles.CARHOUSEADMIN:
          path = path || '/vehicles';
          break;
        case Roles.USER:
          path = path || '/vehicles';
          break;
        default:
          break;
      }

      navigate(path, { replace: true });
    } catch (err) {
      console.log(err);
      message.error('Something wrong');
    }
  };

  const onFinishFailed = (errorInfo) => {
    message.error('Something wrong');
  };

  return (
    <Row className={`${classes.loginWrapper}`} justify="center" align="center">
      <Col className={`${classes.customCol}`}>
        <div className={`${classes.loginCard}`}>
          <div className={`${classes.logo} mb-3`}>
            <img src={logo} alt='Logo' width={250}/>
          </div>
          <Form
            name="basic"
            initialValues={{
              rememberMe: false,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              validateTrigger={['onBlur']}
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Please enter a valid email!',
                },
              ]}
            >
              <Input
                className={`${classes.customInput}`}
                prefix={<MailOutlined className="site-form-item-icon" />}
                placeholder="Email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please enter your password!',
                },
              ]}
            >
              <Input.Password
                className={`${classes.customInput}`}
                prefix={<LockOutlined />}
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item name="rememberMe" valuePropName="checked">
              <Checkbox>Remember me</Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                loading={isLoading}
                size="large"
                className={`${classes.customBtn}`}
                type="primary"
                htmlType="submit"
              >
                {isLoading ? 'Loading ...' : 'Login'}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  );
};

export default LoginForm;
